/** Copyright (c) 2018 T.Rowe Price. All rights reserved. */

export const REQUESTED_BROKERAGE_SSO = 'REQUESTED_BROKERAGE_SSO ';
export const requestedBrokerageAssertion = () => ({
  type: REQUESTED_BROKERAGE_SSO
});

export const RECEIVED_BROKERAGE_SSO = 'RECEIVED_BROKERAGE_SSO';
export const receivedBrokerageAssertion = (ssoResponse) => ({
  type: RECEIVED_BROKERAGE_SSO,
  ssoResponse
});

export const ERROR_BROKERAGE_SSO = 'ERROR_BROKERAGE_SSO ';
export const errorRetrievingBrokerageAssertion = (error) => ({
  type: ERROR_BROKERAGE_SSO,
  error
});

export const REQUESTED_BROKERAGE_MFE = 'REQUESTED_BROKERAGE_MFE ';
export const requestedBrokerageAssertionMFE = () => ({
  type: REQUESTED_BROKERAGE_MFE
});

export const RECEIVED_BROKERAGE_MFE = 'RECEIVED_BROKERAGE_MFE';
export const receivedBrokerageMFE = (mfeResponse) => ({
  type: RECEIVED_BROKERAGE_MFE,
  mfeResponse
});

export const ERROR_BROKERAGE_MFE = 'ERROR_BROKERAGE_MFE';
export const errorRetrievingBrokerageMFE = (error) => ({
  type: ERROR_BROKERAGE_MFE,
  error
});

export const RECIEVED_BROKERAGE_MFE_LOGIN = 'RECIEVED_BROKERAGE_MFE_LOGIN';
export const receivedBrokerageLogin = (error) => ({
  type: RECIEVED_BROKERAGE_MFE_LOGIN,
  error
});

// ICE -
export const REQUESTED_FIXED_INCOME_SSO = 'REQUESTED_ICE_SSO ';
export const requestedFixedIncomeAssertion = () => ({
  type: REQUESTED_FIXED_INCOME_SSO
});

export const RECEIVED_FIXED_INCOME_SSO = 'RECEIVED_FIXED_INCOME_SSO';
export const receivedFixedIncomeAssertion = (ssoResponse) => ({
  type: RECEIVED_FIXED_INCOME_SSO,
  ssoResponse
});

export const ERROR_FIXED_INCOME_SSO = 'ERROR_FIXED_INCOME_SSO ';
export const errorRetrievingFixedIncomeAssertion = (error) => ({
  type: ERROR_FIXED_INCOME_SSO,
  error
});
export const RESET_BROKERAGE_MFE = 'RESET_BROKERAGE_MFE';
export const resetRetrievingBrokerageMFE = (error) => ({
  type: RESET_BROKERAGE_MFE,
  error
});

export const UPDATE_BROKERAGE_MFE_STATE = 'UPDATE_BROKERAGE_MFE_STATE';
export const updateBrokerageMFEState = (payload) => ({
  type: UPDATE_BROKERAGE_MFE_STATE,
  payload
});